var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"logo"}),_vm._v(" "),_c('div',{staticClass:"tit"}),_vm._v(" "),_c('div',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"btn_sub",on:{"click":_vm.goNext}},[_vm._v("开始活动")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-168bf677","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 